import React from "react";

const BetaBadge: React.FC = () => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#F3B233",
      color: "#111",
      borderRadius: "2rem",
      height: "15px",
      lineHeight: 1,
      padding: "0 0.5rem",
      fontWeight: "bold",
      fontSize: "0.7rem",
      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
      zIndex: 10,
      letterSpacing: 0,
    }}
  >
    Beta
  </span>
);

export default BetaBadge;
